import { RouteRecordRaw } from 'vue-router';

const documentsRoutes: Array<RouteRecordRaw> = [
  {
    path: 'documents',
    component: () =>
      import('@/app/Documents/components/documents-index-component.vue'),
    name: 'app.documents',
  },
];

export default documentsRoutes;
